export enum ScoringType {
  LKM = 'LKM',
  LKL = 'LKL',
  RKM = 'RKM',
  RKL = 'RKL'
}
